<template>
  <div
    class="refonte-item-file"
    v-bind:class="props.class">
    <div class="item-file-content-left">
      <div class="item-file-content-title">
        <div class="item-file-content-title-text">
          <div class="item-file-content-title-text-top">
            {{ props.title }}
          </div>
          <div
            v-if="props.subtitle"
            class="item-file-content-title-text-bottom">
            {{ props.subtitle }}
          </div>
        </div>
      </div>
    </div>
    <div class="item-file-content-middle">
      <div class="item-file-content-status">
        <div v-bind:class="`item-file-content-status-text text-jinius-green'`">
          <div class="item-file-content-status-text-icon">
            <IconValidate20 class="text-jinius-green" />
          </div>
          <span class="text-refonte_blue-300">{{ 'À consulter' }}</span>
        </div>
      </div>
    </div>
    <div class="item-file-content-right">
      <refonte-button
        v-if="props.on_click_download"
        class="item-file-content-download"
        variant="secondary"
        v-bind:icon_left="IconDownload"
        v-on:click="props.on_click_download"
        v-tooltip="'Télécharger'">
        Télécharger
      </refonte-button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconValidate20 from '@/assets/img/refonte/icons/information/icon-validate-20.svg?component';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { onMounted, ref } from 'vue';
  import { Contrat } from '@/types/gestion/contrats-types';

  const props = withDefaults(
    defineProps<{
      title: string;
      subtitle?: string;
      contrat: Contrat;
      on_click_download?: Function;
      formation_title?: string;
      session_date?: string;
      participant_nom_prenom?: string;
      client_id?: number;
      class?: string;
      on_close?: Function;
      on_submit?: Function;
    }>(),
    {
      class: ''
    }
  );
  const input = ref(null);

  onMounted(() => {
    if (input.value) {
      input.value.focus();
    }
  });
</script>

<style lang="scss" scoped>
  .refonte-item-file {
    @apply flex flex-grow bg-refonte-pale-violet-2;
    gap: 4px;
    border-radius: 8px;
    padding: 6px 12px 6px 12px;
    max-width: 700px;
    width: 100%;
    min-height: 48px;

    .item-file-content-left {
      @apply flex items-center;
      gap: 4px;
      width: 33.33%;

      .item-file-content-title {
        @apply flex flex-grow items-start;
        gap: 2px;

        .item-file-content-title-text {
          @apply flex flex-grow flex-col items-start;
          gap: 2px;

          .item-file-content-title-text-top {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
          }

          .item-file-content-title-text-bottom {
            @apply self-stretch overflow-hidden text-ellipsis text-refonte-black-40;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }
    }

    .item-file-content-middle {
      @apply flex items-center;
      width: 33.33%;
      gap: 4px;

      .item-file-content-status {
        @apply flex flex-grow items-center;
        gap: 4px;

        .item-file-content-status-text {
          @apply flex flex-grow items-center;
          gap: 2px;
          margin-right: 6px;

          .item-file-content-status-text-icon {
            @apply flex shrink-0 items-center justify-center;
            width: 20px;
            height: 20px;

            :deep(svg) {
              width: 18px;
              height: 18px;
            }
          }

          span {
            @apply whitespace-nowrap;
            font-size: 13px;
            line-height: 16px;
            font-weight: 400;
          }
        }
      }
    }

    .item-file-content-right {
      @apply flex justify-end;
      width: 33.33%;
      gap: 6px;

      .item-file-content-download {
        gap: 2px;
      }

      .item-file-content-sign {
        gap: 8px;
      }
    }

    @media (max-width: 515.98px) {
      @apply flex-col items-stretch;

      .item-file-content-left {
        max-width: 100%;

        .item-file-content-download-separator {
          @apply hidden;
        }
      }
    }
  }
</style>
